import useTabs from 'shared/state/useTabs'
import { TabProps } from './Tab'

export const TabPanel = ({ index, children, className }: TabProps) => {
  const { activeTab, hasRenderedTab } = useTabs()

  const isActiveTab = activeTab === index

  /**
   * In order to persist local state we sometimes do not want to
   * unmount the component after switching tabs. (a good example would be a tab specific form)
   * Note - the tab will not perform an initial render until it is visited at least once to save on unnecessary network requests
   * that might exist in the tab.
   */
  if (!isActiveTab && !hasRenderedTab(index)) {
    return null
  }

  return (
    <div
      tabIndex={0}
      role="tabpanel"
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      hidden={activeTab !== index}
      className={className}
    >
      {children}
    </div>
  )
}
